export default __webpack_public_path__ + "static/media/team_normal.07194fc2.png";